<template>
<div class="leftover-options-summary">
  <MealCard
    class="list-complete-item"
    v-for="(dish, i) in leftoverDishes"
    :key="dish.dishType + '-' + dish.recipeId + '-' + dish.parentDishId"
    :dish="plannedOption(dish)"
    :cardType="'meal'"
    :isLeftoverOption="true"
    :appliedMealtime="data.mealTime"
    :summary="isOptionsPlanned(dish)"
    @showDishDetails="showDishDetails(dish.recipeId)"
  />
</div>
</template>

<script>
import {
  planComputed,
  planMethods,
  dishesComputed,
  dishesMethods,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  recipesComputed,
  recipesMethods,
} from '@state/helpers';
import MealCard from '../MealCard/MealCard';

export default {
  components: {
    MealCard,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {},
  },
  data() {
    return {};
  },
  computed: {
    ...planComputed,
    ...dishesComputed,
    ...kitchenDrawerComputed,
    ...recipesComputed,
    leftoverDishes() {
      if (this.dailySummary) {
        return this.dailySummary.day[this.data.mealTime].leftoverOptions.map((option) => {
          return { ...option, dishType: 'r' };
        });
      }
    },
  },
  mounted() {
    this.leftoverDishes.forEach((dish) => {
      if (!this.cachedRecipesMap[dish.recipeId]) {
        this.getRecipe(dish.recipeId);
      }
    });
  },
  methods: {
    ...planMethods,
    ...dishesMethods,
    ...kitchenDrawerMethods,
    ...recipesMethods,
    async showDishDetails(dishId) {
      if (!this.cachedRecipesMap[dishId]) {
        await this.getRecipe(dishId);
      }

      this.navigateDeeper({
        title: 'Leftover Option',
        component: 'RecipeDetail',
        data: {
          ...this.dailySummary.day[this.data.mealTime].leftoverOptions.find((leftover) => leftover.recipeId === dishId),
          ...this.dailySummary.day[this.data.mealTime].leftovers.find((leftover) => leftover.id === dishId),
          ...this.cachedRecipesMap[dishId],
          isLeftover: true,
          onRemove: (dishId) => {},
        },
      });
    },
    plannedOption(dish) {
      const leftover = {
        ...dish,
        ...this.dailySummary.day[this.data.mealTime].leftovers.find((leftover) => leftover.id === dish.recipeId),
      };
      return leftover;
    },
    isOptionsPlanned(dish) {
      if (this.dailySummary) {
        return this.dailySummary.day[this.data.mealTime].leftovers.find((leftover) => leftover.id === dish.recipeId) !== undefined;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.leftover-options-summary {
  @extend %scrollable-drawer-content;

  padding: 0.6rem 1rem 11rem;
}
</style>
